import NeutralisApp from './themes/neutralis/ThemedApp';

export const routes = [
  {
    "path": "/themes/neutralis",
    "element": <NeutralisApp/>
  }
];
